import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { pmsAuthMfaSend, pmsAuthMfaSendToHotel } from '@/apis/aipass'
import { getMfaErrorMessage, MfaErrorResponse } from './mfa-error-message'

// 失敗時は画面に出す文言を返す。翻訳は表示側で行う
const createSendOtpThunk = (typePrefix: string, send: (idToken: string) => Promise<unknown>) =>
  createAsyncThunk<void, string, { rejectValue: string }>(typePrefix, async (idToken, { rejectWithValue }) => {
    try {
      await send(idToken)
    } catch (error) {
      return rejectWithValue(getMfaErrorMessage(error as AxiosError<MfaErrorResponse>, 'otp_send_unavailable'))
    }
  })

export const sendMfaOtpToEmployee = createSendOtpThunk('mfa/sendOtpToEmployee', pmsAuthMfaSend)
export const sendMfaOtpToHotel = createSendOtpThunk('mfa/sendOtpToHotel', pmsAuthMfaSendToHotel)
